export const ABOUT_PILLARS = [
  {
    title: 'Real tracking',
    body: 'Picks are captured from the sources experts already use—Discord, Twitter/X, newsletters, Telegram, and more—then scored against real outcomes.',
    iconPath:
      'M3 13h2v8H3v-8zm4-4h2v12H7V9zm4-4h2v16h-2V5zm4 6h2v10h-2V11zm4-8h2v18h-2V3z',
    color: 'primary.400',
  },
  {
    title: 'Transparent scoring',
    body: 'Clear metrics like WCS (win-rate skill), PR, and ROI—not opaque “lock of the day” claims. Every pick is tracked and verified.',
    iconPath:
      'M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-1 16l-4-4 1.41-1.41L11 14.17l6.59-6.59L19 9l-8 8z',
    color: 'accent.success',
  },
  {
    title: 'Actionable signals',
    body: 'Hot picks, consensus, and performance breakdowns by sport and bet type so you can see who is hot—and who is not—before you decide.',
    iconPath:
      'M11 21h-1l1-7H7.5c-.88 0-.33-.75-.31-.78C8.48 10.94 10.42 7.54 13.01 3h1l-1 7h3.51c.4 0 .62.19.4.66C12.97 17.55 11 21 11 21z',
    color: 'accent.warning',
  },
] as const;
